export const FindAvailableCoordinates = (widgets, widget, maxCols = 12) => {
    if (!Array.isArray(widgets) || widgets.length === 0) {
        return { row: 0, col: 0 };
    }

    const newWidth = widget?.sizeX || 1;

    let last = widgets[0];
    let lastBottom = last.row + last.sizeY;

    for (const w of widgets) {
        const bottom = w.row + w.sizeY;
        const colEnd = w.col + w.sizeX;
        const lastColEnd = last.col + last.sizeX;
        if (bottom > lastBottom || (bottom === lastBottom && (w.row > last.row || (w.row === last.row && colEnd > lastColEnd)))) {
            last = w;
            lastBottom = bottom;
        }
    }

    const nextCol = last.col + last.sizeX;

    if (nextCol + newWidth <= maxCols) {
        return {
            row: last.row,
            col: nextCol,
        };
    } else {
        return {
            row: last.row + last.sizeY,
            col: 0,
        };
    }
};
